import axios from 'axios';

// const baseUrl = 'http://172.30.100.154:9997/api/inventory';
const baseUrl = 'http://54.180.215.7:9997/api/inventory';
// const baseUrl = 'http://localhost:9997/api/inventory';

export async function fetchTotalProducts(date, days) {
  const response = await axios.get(`${baseUrl}/barcodes/issue-and-usage-percentage`, {
    params: { date: date, days: days }
  });
  return response.data;
}

export async function fetchLowStockProducts(date, days) {
  const response = await axios.get(`${baseUrl}/low-stock-products-count`, {
    params: { date: date, days: days }
  });
  return response.data;
}

export async function fetchOutOfStockProducts(date, days) {
  const response = await axios.get(`${baseUrl}/out-of-stock-products-count`, {
    params: { date: date, days: days }
  });
  return response.data;
}

export async function fetchZeroStockProducts(date, days) {
  const response = await axios.get(`${baseUrl}/zero-stock-products-count`, {
    params: { date: date, days: days }
  });
  return response.data;
}

export async function fetchBarcodeScanData(date, days) {
  const response = await axios.get(`${baseUrl}/barcodes/issue-and-usage-count`, {
    params: { date: date, days: days }
  });
  return response.data;
}

export async function fetchThresholdApproachingData(date, days) {
  const response = await axios.get(`${baseUrl}/low-stock-products`, {
    params: { date: date, days: days }
  });
  return response.data;
}

export async function fetchOutOfStockProductsData(date, days) {
  const response = await axios.get(`${baseUrl}/zero-stock-products`, {
    params: { date: date, days: days }
  });
  return response.data;
}

export async function fetchAverageRemainingStockProductsData(date, days) {
  const response = await axios.get(`${baseUrl}/average-remaining-stock`, {
    params: { date: date, days: days }
  });
  return response.data;
}

export async function fetchThresholdReachedData(date, days) {
  const response = await axios.get(`${baseUrl}/out-of-stock-products`, {
    params: { date: date, days: days }
  });
  return response.data;
}

export async function fetchInOutStockData(date, days) {
  const response = await axios.get(`${baseUrl}/daily-summary`, {
    params: { date: date, days: days }
  });
  return response.data;
}
